/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DefinitionActionKindEnum {
    Confirm = 10000,
    Upload = 20000,
    Sign = 30000,
    Reject = 40000,
    Rework = 50000,
    Delete = 60000,
    Form = 70000,
}
